module.exports = __webpack_public_path__ + "img/tecnici.b5d9eab9.png";